// pages/ReportsPage.jsx
import { useState, useEffect } from 'react';
import { useAuth } from '../utils/auth';
import { reports as reportsApi } from '../utils/api';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Download } from 'lucide-react';
import toast from 'react-hot-toast';

export function ReportsPage() {
  const [date, setDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await reportsApi.daily(date);
      setData(r.data);
    } catch { toast.error('Erreur chargement rapport'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [date]);

  const printReport = () => window.print();

  return (
    <>
      <div className="page-header">
        <div><h2>Rapports</h2><p>Fiche récap journalière</p></div>
        <div style={{display:'flex',gap:8}}>
          <input type="date" className="input" style={{width:'auto'}} value={date} onChange={e=>setDate(e.target.value)} />
          <button className="btn btn-secondary" onClick={printReport}><Download size={15}/> Imprimer</button>
        </div>
      </div>

      <div className="page-body">
        {loading ? <div className="empty-state"><span className="spinner"/></div> : data && (
          <>
            <div className="stat-grid" style={{marginBottom:20}}>
              <div className="stat-card">
                <div className="stat-value">{data.summary.sessionCount}</div>
                <div className="stat-label">Sessions</div>
              </div>
              <div className="stat-card">
                <div className="stat-value" style={{color:'var(--teal)'}}>{data.summary.grandTotal} €</div>
                <div className="stat-label">Total encaissé</div>
              </div>
              {data.totals?.map(t=>(
                <div key={t.code} className="stat-card">
                  <div className="stat-value">{t.total} €</div>
                  <div className="stat-label">{t.name}</div>
                </div>
              ))}
            </div>

            <div className="card" style={{marginBottom:20}}>
              <div className="card-title" style={{marginBottom:16}}>
                Détail des sessions — {format(new Date(date), "EEEE d MMMM", {locale:fr})}
              </div>
              <div className="table-wrap">
                <table>
                  <thead><tr>
                    <th>Réf</th><th>Heure</th><th>Salle</th><th>Client</th>
                    <th>Joueurs</th><th>Montant</th><th>Payé</th><th>Moyens de paiement</th>
                  </tr></thead>
                  <tbody>
                    {data.sessions.map(s=>(
                      <tr key={s.id}>
                        <td className="font-mono text-sm text-accent">{s.booking_ref}</td>
                        <td className="font-mono">{s.session_start?.slice(0,5)}</td>
                        <td className="bold">{s.room_name}</td>
                        <td>{s.customer_name}</td>
                        <td>{s.player_count}</td>
                        <td className="bold">{s.total_amount} €</td>
                        <td className="text-green bold">{s.amount_paid} €</td>
                        <td className="text-sm">
                          {s.payments_detail?.map((p,i)=>(
                            <span key={i}>{p.method}: {parseFloat(p.amount).toFixed(2)}€ </span>
                          ))||'—'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {data.sales?.length > 0 && (
              <div className="card">
                <div className="card-title" style={{marginBottom:16}}>Ventes produits</div>
                <div className="table-wrap">
                  <table>
                    <thead><tr><th>Produit</th><th>Quantité</th><th>Total</th></tr></thead>
                    <tbody>
                      {data.sales.map(s=>(
                        <tr key={s.name}>
                          <td>{s.name}</td><td>{s.qty}</td>
                          <td className="bold text-teal">{s.total} €</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default ReportsPage;
